import { render, staticRenderFns } from "./dialog-test-messages.vue?vue&type=template&id=508fe9e2&scoped=true&"
import script from "./dialog-test-messages.vue?vue&type=script&lang=js&"
export * from "./dialog-test-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508fe9e2",
  null
  
)

export default component.exports